module.exports = __webpack_public_path__ + "img/logo_ru_old.d026f60d.png";